import {
    Text as ChakraText,
    TextProps as ChakraTextProps,
    Heading,
    HeadingProps,
    LinkProps,
} from '@chakra-ui/react';
import { FC } from 'react';
import { linkHoverStyleProps } from './styleHelpers';

export const HeroText: FC<HeadingProps> = (props) => (
    <Heading
        as="h1"
        fontSize="7xl"
        fontWeight="500"
        color="text"
        letterSpacing="tight"
        {...props}
    />
);

export const Title: FC<HeadingProps> = (props) => (
    <Heading
        as="h1"
        fontSize="3xl"
        fontWeight="semibold"
        color="text"
        letterSpacing="tight"
        {...props}
    />
);

export const BigHeader: FC<HeadingProps> = (props) => (
    <Heading
        as="h1"
        fontSize="2xl"
        fontWeight="semibold"
        letterSpacing="tight"
        color="text"
        {...props}
    />
);

export const Header: FC<HeadingProps> = (props) => (
    <Heading
        as="h2"
        fontSize="lgr"
        fontWeight="medium"
        color="text"
        lineHeight={1.33}
        {...props}
    />
);

export const Subheader: FC<HeadingProps> = (props) => (
    <Heading
        as="h3"
        fontSize="lg"
        fontWeight="semibold"
        color="text"
        {...props}
    />
);

export const EyebrowHeader: FC<HeadingProps> = (props) => (
    <Heading
        as="h4"
        fontSize="sm"
        mb=".5em"
        fontWeight="medium"
        color="textMuted"
        fontFamily="mono"
        textTransform="uppercase"
        {...props}
    />
);

export type TextProps = ChakraTextProps;

// Re-export with fontSize="md" to enforce base text size of 14px without
// resetting the global font size.
// Note: This is better-suited to Chakra's theme pattern, but unfortunately
// Chakra doesn't expose theme customization for the Text component.
export const Text: FC<TextProps> = (props) => (
    <ChakraText as="span" fontSize="md" {...props} />
);

export const BigParagraph: FC<TextProps> = (props) => (
    <Text as="p" lineHeight="taller" fontSize="xl" {...props} />
);

export const Paragraph: FC<TextProps> = (props) => (
    <Text as="p" lineHeight="tall" {...props} />
);

export interface LinkTextProps
    extends TextProps,
        Pick<LinkProps, 'href' | 'target'> {
    withUnderline?: boolean;
}

export const LinkText = ({ withUnderline, ...props }: LinkTextProps) => (
    <Text
        as="a"
        {...linkHoverStyleProps()}
        color="blue.500"
        textDecoration={withUnderline ? 'underline' : 'none'}
        {...props}
    />
);

export const Highlight: FC<TextProps> = ({
    colorScheme,
    ...props
}: TextProps) => (
    <Text
        as="span"
        align="right"
        bg={`${colorScheme}.100`}
        color={`${colorScheme}.600`}
        rounded={2}
        fontSize="2xs"
        letterSpacing="wider"
        px={1}
        py={0.5}
        textTransform="uppercase"
        whiteSpace="nowrap"
        {...props}
    />
);
